module.exports = __webpack_public_path__ + "img/14csm_Ersa-VERSAFLOW-ONE-03-1920x540_d664b52851.b098742d.jpg";